import commonUtils from "./utils/commonUtils";

class Rest {

    async get(url) {
        const options = {
            method: "get",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" }
        };
        const response = await fetch(encodeURI(url), options);
        return this.handleErrors(response);
    }

    async post(url, object) {
        const options = {
            method: "post",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(object),
        };
        const response = await fetch(encodeURI(url), options);
        return this.handleErrors(response);
    }

    async form(url, formData) {
        const options = {
            method: "post",
            credentials: "same-origin",
            body: formData,
        };
        const response = await fetch(encodeURI(url), options);
        return this.handleErrors(response);
    }

    async file(url, name, file, ...params) {
        const formData = new FormData();
        formData.append("file", new Blob([file]), name);
        params?.forEach((param, index) => {
            formData.append(`param-${index}`, param);
        });
        const options = {
            method: "post",
            credentials: "same-origin",
            body: formData,
        };
        const response = await fetch(encodeURI(url), options);
        return rest.handleErrors(response);
    }

    async handleErrors(response) {
        if (!response.ok || response.redirected === true) {
            const error = await response.json();
            commonUtils.dispatchEvent("exception", error);
            throw Error(error.message);
        }
        return response;
    }
}
const rest = new Rest();
export default rest;